import RewardIcon from "@/icons/RewardIcon";
import {
  centered,
  completedWrapper,
  completeHeaderImage,
  completeIcon,
  floatingText,
  rewardIconCss,
  rewardWrapper,
  textCompleteCss,
} from "./GuidedHighlightingCompleteMessage.style";

interface IGuidedHighlightingCompleteMessageProps {
  isCompleted: boolean;
  tokensEarned: number;
  isStudent: boolean;
  shouldShowTokens: boolean;
}

const GuidedHighlightingCompleteMessage = ({
  isCompleted,
  tokensEarned,
  isStudent,
  shouldShowTokens,
}: IGuidedHighlightingCompleteMessageProps) => {
  const renderRightCompleteImage = () => {
    switch (tokensEarned) {
      case 5:
        return (
          <img
            src="/images/icons/highlight_complete_way_go.svg"
            css={completeIcon}
            alt="GH complete"
          />
        );
      case 10:
        return (
          <img
            src="/images/icons/highlight_complete_way_go.svg"
            css={completeIcon}
            alt="GH complete"
          />
        );
      case 15:
        return (
          <img
            src="/images/icons/highlight_complete_good_job.svg"
            css={completeIcon}
            alt="GH complete"
          />
        );
      case 20:
        return (
          <img
            src="/images/icons/highlight_complete_good_job.svg"
            css={completeIcon}
            alt="GH complete"
          />
        );
      default:
        return (
          <img
            src="/images/icons/highlight_complete_dont_giveup.svg"
            css={completeIcon}
            alt="GH complete"
          />
        );
    }
  };

  const returnCompleteText = () => {
    switch (tokensEarned) {
      case 5:
        return "Way to go!";
      case 10:
        return "Way to go!";
      case 15:
        return "Good job!";
      case 20:
        return "Great job!";
      default:
        return "Don't give up!";
    }
  };

  return isCompleted && isStudent ? (
    <div css={centered}>
      <div css={completedWrapper}>
        {tokensEarned >= 10 && (
          <img
            src="/images/icons/highlight_confetti.svg"
            css={completeHeaderImage}
            alt="GH confetti"
          />
        )}
        {renderRightCompleteImage()}
        <div css={rewardWrapper}>
          <div css={floatingText(shouldShowTokens)}>
            {`${tokensEarned} pts`}
          </div>
          {shouldShowTokens && (
            <RewardIcon
              css={rewardIconCss}
              aria-hidden={false}
              aria-label="Tokens icon"
            />
          )}
        </div>
      </div>
      <p css={textCompleteCss}>{returnCompleteText()}</p>
    </div>
  ) : (
    <> </>
  );
};

export default GuidedHighlightingCompleteMessage;
